import { NgModule } from '@angular/core';
import { TrackedMenuItemsPipe } from './tracked-menu-items.pipe';

@NgModule({
  declarations: [TrackedMenuItemsPipe],
  exports: [TrackedMenuItemsPipe],
})
export class TrackedMenuItemsModule {}
